export default __webpack_public_path__ + "static/small-image-completely-2-c004480d98f4879355eb76a46f592608.png";